import axios from "axios"
import tinycolor from "tinycolor2"

// axios settings
axios.defaults.withCredentials = true

export const DEFAULT_ISOMER_PRIMARY_COLOR = "#6031b6"
export const DEFAULT_ISOMER_SECONDARY_COLOR = "#4372d6"

const defaultSiteColors = {
  default: {
    primaryColor: DEFAULT_ISOMER_PRIMARY_COLOR,
    secondaryColor: DEFAULT_ISOMER_SECONDARY_COLOR,
  },
}

const getStyleSheet = (uniqueTitle) => {
  for (let i = 0; i < document.styleSheets.length; i += 1) {
    const sheet = document.styleSheets[i]
    if (sheet.title === uniqueTitle) {
      return sheet
    }
  }

  return undefined
}

const createPageStyleSheet = (repoName, primaryColor, secondaryColor) => {
  const styleElement = document.createElement("style")
  const styleTitle = `custom-style`
  const existingStyleElement = document.getElementById(styleTitle)

  // Remove existing stylesheet if it exists
  if (existingStyleElement) {
    existingStyleElement.parentNode.removeChild(existingStyleElement)
  }

  styleElement.setAttribute("id", styleTitle)
  styleElement.setAttribute("title", styleTitle)
  document.head.appendChild(styleElement)

  const secondaryColorHover = tinycolor(secondaryColor).lighten(10).toString()
  const customStyleSheet = getStyleSheet(styleTitle)

  // breadcrumb - primary color
  customStyleSheet.insertRule(
    `.bp-section.bp-section-pagetitle { background-color: ${primaryColor} !important;}`,
    0
  )

  // EditHomepage: key highlights - primary color
  customStyleSheet.insertRule(
    `#key-highlights { background-color: ${primaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `#key-highlights .col { background-color: ${primaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `#key-highlights .col:hover { background-color: ${primaryColor} !important;}`,
    0
  )

  // EditHomepage: site notifications - secondary color
  customStyleSheet.insertRule(
    `.bg-secondary { background-color: ${secondaryColor} !important;}`,
    0
  )

  // EditHomepage: hero button - secondary color
  customStyleSheet.insertRule(
    `.is-secondary { background-color: ${secondaryColor} !important; color: #fff !important;}`,
    0
  )

  // EditHomepage: info section button text - secondary color
  customStyleSheet.insertRule(
    `.bp-sec-button span { color: ${secondaryColor} !important; border-bottom: 2px solid ${secondaryColor} !important}`,
    0
  )
  customStyleSheet.insertRule(
    `.bp-sec-button:hover span { color: ${secondaryColor} !important; border-bottom: 2px solid ${secondaryColor} !important}`,
    0
  )
  customStyleSheet.insertRule(
    `.bp-sec-button .sgds-icon { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.bp-sec-button .sgds-icon:before { color: ${secondaryColor} !important;}`,
    0
  )

  // EditPage: headings - secondary color
  customStyleSheet.insertRule(
    `.content h1 strong { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.content h2 strong { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.content h3 strong { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.content h4 strong { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.content h5 strong { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.content h1 { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.content h2 { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.content h3 { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.content h4 { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.content h5 { color: ${secondaryColor} !important;}`,
    0
  )

  // EditPage: Blockquotes
  customStyleSheet.insertRule(
    `.content blockquote { border-left-color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.content blockquote > p { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.content blockquote > ul { color: ${secondaryColor} !important;}`,
    0
  )

  customStyleSheet.insertRule(
    `.has-text-secondary { color: ${secondaryColor} !important;}`,
    0
  )

  // EditPage: left nav - secondary color
  customStyleSheet.insertRule(
    `.bp-menu-list a.is-active { color: ${secondaryColor} !important; border-bottom: 2px solid ${secondaryColor} !important}`,
    0
  )
  customStyleSheet.insertRule(
    `.bp-menu-list a.is-active:hover { color: ${secondaryColor} !important; border-bottom: 2px solid ${secondaryColor} !important}`,
    0
  )
  customStyleSheet.insertRule(
    `.bp-menu-list a:hover { color: ${secondaryColor} !important; border-bottom: 2px solid ${secondaryColor} !important}`,
    0
  )
  customStyleSheet.insertRule(
    `.sgds-icon.bx-chevron-up:before { color: ${secondaryColor} !important;}`,
    0
  )
  customStyleSheet.insertRule(
    `.sgds-icon.bx-chevron-down:before { color: ${secondaryColor} !important;}`,
    0
  )

  customStyleSheet.insertRule(
    `:root { --site-primary-color: ${primaryColor} !important; --site-secondary-color: ${secondaryColor} !important; --site-secondary-color-hover: ${secondaryColorHover} !important;}`,
    0
  )
}

const getSiteColors = async (siteName) => {
  try {
    // get settings data from backend
    const settingsResp = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL_V2}/sites/${siteName}/settings`
    )
    const { colors } = settingsResp.data

    return {
      primaryColor: colors?.["primary-color"] || DEFAULT_ISOMER_PRIMARY_COLOR,
      secondaryColor:
        colors?.["secondary-color"] || DEFAULT_ISOMER_SECONDARY_COLOR,
    }
  } catch (err) {
    console.log(err)
    throw err
  }
}

export { defaultSiteColors, createPageStyleSheet, getSiteColors }
